export default {
  newDesign: true,
  title: "Çocuğunuzla aynı frekansta mısınız? | Kodland",
  parameters: {
    landing_id: "TrQuUnPaid",
    segment: 11
  },
  downtimeUrl: "http://kodland.org/tr",
  startPage: {
    title:
      "1 dakikada testi yapın ve çocuğunuzun memelerini ve slangını anlayıp anlamadığınızı öğrenin!",
    subtitle:
      "✅ Gençlerle hazırlandı<br>👨‍👩‍👧‍👦 +100.000 aile bize güveniyor<br>🎁 Test sonuna özel hediye",
    image: {
      url: "/welcome/tr_content_understanding_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_content_understanding_paid_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Teste Başla! 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Aşağıdakilerden hangisi popüler bir TikTok esprili paylaşım/meme'idir?",
      answers: ["lalala lama 🦙", "wiwiwi wiwi 😅", "rrr parrot 🦜"],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid1.png",
      subtitle:
        "TikTok'ta herkes şu sıralar «wiwiwi» diyen sevimli bir yavru kediyi konuşuyor. Belki bunu çocuğunuzu sofraya çağırmak için siz de deneyebilirsiniz!",
      button: "¡Wiwiwi!",
    },
    3: {
      question: "Bu karakterin nereden olduğunu biliyor musunuz?",
      image: {
        answeWithImage: true,
        image_main: "/welcome/paid2.png",
        imageMobile: "",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        "Bir çizgi filmden mi acaba?",
        "Tabii ki Lego’dan!",
        "Tabii ki Minecraft’tan!",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid3.png",
      subtitle:
        "Bazı oyunlar daha gerçekçi grafikler için yarışırken gençlerin favorisi hâlâ Minecraft – tamamı bloklardan oluşan bir dünya.",
      button: "Denemeliyim!",
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid4_tr.png",
      subtitle:
        "Bu arada, Kodland’de online oyun geliştirme kurslarımız var. Eğer çocuğunuz oyun dünyasında çok zaman geçiriyorsa, kendi oyunlarını tasarlamak ona çok cazip gelebilir! Testi tamamlayın ve ücretsiz denemeniz için harika bir hediye alın 🎁",
      button: "Devam et",
    },
    6: {
      question: "Sizce çocuğunuz bir şeylerin CEO’su olabilir mi?",
      answers: [
        "Büyüyünce belki olur…",
        "Evet, kesinlikle dağınıklığın CEO’su!",
      ],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid5.png",
      subtitle:
        "Ergen dünyasında, CEO olmak için şirket yönetmek gerekmiyor! «Bir şeyin CEO’su olmak» ifadesi, bir konuda çok iyi olmak demek.",
      button: "Slang CEO’su olacağım!",
    },
    8: {
      question: "Çocuğunuz size «delulu» derse alınmalı mısınız?",
      answers: [
        "Tatlı bir kelime, bence alınmamalıyım!",
        "Asıl delulu kendisi!",
      ],
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid6.png",
      subtitle:
        "«Delulu», İngilizce «delusional» kelimesinin kısaltmasıdır ve gerçeklikten kopmuş kişiler için kullanılır.",
      button: "Tamam!",
    },
    10: {
      question: "Çocuğunuz kişisel konuları sizinle paylaşıyor mu?",
      answers: [
        "Evet, her şeyi konuşuyoruz",
        "Hayır, ben arkadaşı değilim",
        "İsterdim, ama olmuyor",
      ],
    },
    11: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid7_tr.png",
      subtitle:
        "Çocuk ve ebeveyn arasındaki bağ çok önemlidir, ancak çocuk büyürken sizden uzaklaşıyor gibi görünebilir. Bu doğal bir süreçtir.",
      button: "Sabırlı olacağım",
    },
    12: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    13: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    14: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/paid8_tr.png",
      title: "Umarız testimiz sizin için faydalı olmuştur!",
      subtitle:
        "🎁 Hediyenizi unutmayın: Çocuğunuz için Kodland'de profesyonel öğretmen eşliğinde ücretsiz online programlama dersi.",
      button: "Ücretsiz dersi alın",
    },
    15: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    16: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    17: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    18: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    19: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
